import React from 'react'
import InputGlobal from '../InputGlobal'
import { Tooltip } from '@material-tailwind/react'
import { SquarePlus, Trash } from 'lucide-react'
import { useFieldArray } from 'react-hook-form'

const HorariosForms = ({register,control,errors}) => {
const { fields, append, remove } = useFieldArray({
    control,
    name: "dias_realizados",
  });
  return (
    <div className='w-full flex items-center flex-col max-h-[150px] overflow-auto'>
    {fields.map((field, index) => ( <div className='w-[80%] flex gap-5 '>
        <InputGlobal
            type="date"
            label="Data"
            // formCamp="date"
            formCamp={`dias_realizados.${index}.date`}
            register={register}
            validations={{ required: true }}
            required={true}
            errors={errors?.dias_realizados?.[index]?.date}
          />
            <InputGlobal
            type="time"
            label="Hora entrada"
            formCamp={`dias_realizados.${index}.start_time`}
            // placeholder="Hora de entrada"
            register={register}
            validations={{ required: true }}
            required={true}
            errors={errors?.dias_realizados?.[index]?.start_time}
          />
            <InputGlobal
            type="time"
            label="Hora Almoço  "
            formCamp={`dias_realizados.${index}.lunch_start`}
            placeholder="Hora do almoço"
            register={register}
            validations={{ required: true }}
            required={true}
            errors={errors?.dias_realizados?.[index]?.lunch_start}
          />
          <InputGlobal
            type="time"
            label="Volta almoço"
            formCamp={`dias_realizados.${index}.lunch_end`}
            placeholder="Volta do almoço"
            register={register}
            validations={{ required: true }}
            required={true}
            errors={errors?.dias_realizados?.[index]?.lunch_end}
          />
          <InputGlobal
            type="time"
            label="Hora saida"
            formCamp={`dias_realizados.${index}.end_time`}
            placeholder="Hora de saida"
            register={register}
            validations={{ required: true }}
            required={true}
            errors={errors?.dias_realizados?.[index]?.end_time}
          />
          {index === 0 && (

            <Tooltip content="Criar adicionar +" className="dark:opacity-100 dark:text-darkText cursor-pointer justify-center">
                <SquarePlus
                  className="dark:opacity-100 dark:text-green-500 cursor-pointer items-center mt-6 "
                  onClick={() => append({ date: "", start_time: "", lunch_start: "00",lunch_end:"",end_time:"" })}
                  size={40}
                />
          </Tooltip>
          )}
          {index > 0 && (

            <Tooltip content="Criar adicionar +" className="dark:opacity-100 dark:text-darkText cursor-pointer justify-center">
                <Trash
                  className="dark:opacity-100 dark:text-red-500 cursor-pointer items-center mt-6  "
                   onClick={() => remove(index)}
                  size={40}
                />
          </Tooltip>
      )}
        </div>))}
    </div>
   
  )
}

export default HorariosForms